(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glow-offer"]) return;
  try {
    
if (!customElements.get('glow-offer-clock')) {
  customElements.define('glow-offer-clock', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline);
      if (!Number.isFinite(this.deadline)) return;
      this.update();
      if (!this.hidden) this.tick = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.tick); }
    update() {
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.hidden = seconds === 0;
      if (this.hidden) { clearInterval(this.tick); return; }
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor(seconds % 3600 / 60);
      const remaining = seconds % 60;
      const parts = hours > 0 ? [hours, minutes, remaining] : [minutes, remaining];
      this.querySelector('[data-clock]').textContent = parts.map(n => String(n).padStart(2, '0')).join(':');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glow-product"]) return;
  try {
    
function initGlowProduct(scope){
 scope.querySelectorAll('[data-product-section]').forEach(section=>{
  if(section.dataset.ready)return;
  section.dataset.ready='true';
  const imageWrap=section.querySelector('.main-image');
  const image=imageWrap.querySelector('img');
  const panel=section.querySelector('[data-results-panel]');
  const thumbs=Array.from(section.querySelectorAll('.thumbnails button'));
  let active=0;
  function selectImage(index){
   active=(index+thumbs.length)%thumbs.length;
   const button=thumbs[active];
   const isPair=button.hasAttribute('data-results-trigger');
   imageWrap.hidden=isPair;
   panel.hidden=!isPair;
   if(!isPair){image.src=button.dataset.galleryImage;image.removeAttribute('srcset');image.alt=button.dataset.imageAlt||'';}
   thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));
   const strip=button.parentElement;
   strip.scrollTo({left:Math.max(0,button.offsetLeft-strip.offsetLeft-(strip.clientWidth-button.clientWidth)/2),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  thumbs.forEach((button,index)=>button.addEventListener('click',()=>selectImage(index)));
  section.querySelector('[data-gallery-prev]').addEventListener('click',()=>selectImage(active-1));
  section.querySelector('[data-gallery-next]').addEventListener('click',()=>selectImage(active+1));
  let touchX=null;
  imageWrap.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].screenX},{passive:true});
  imageWrap.addEventListener('touchend',event=>{if(touchX!==null){const delta=event.changedTouches[0].screenX-touchX;if(Math.abs(delta)>60)selectImage(active+(delta<0?1:-1));touchX=null;}},{passive:true});
  section.querySelectorAll('.pack-option input').forEach(input=>input.addEventListener('change',()=>{
   section.querySelector('[data-product-price]').textContent=input.dataset.price;
   const button=section.querySelector('[data-add-button]');
   button.disabled=input.dataset.available!=='true';
   button.querySelector('[data-buy-label]').textContent=button.disabled?button.dataset.soldOutText:input.dataset.buyLabel;
   const url=new URL(window.location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);
  }));
 });
}
initGlowProduct(document);document.addEventListener('shopify:section:load',event=>initGlowProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowmela-plinko"] && !Shopify.designMode) return;
  try {
    
function glowmelaDiscountLink({ storeUrl, code, redirectPath = '/collections/all' }) {
  const store = new URL(storeUrl);
  if (store.protocol !== 'https:' || store.username || store.password || store.pathname !== '/' || store.search || store.hash) {
    throw new TypeError('storeUrl must be the HTTPS storefront origin.');
  }
  if (typeof code !== 'string' || !code.trim() || code.length > 255 || /[\x00-\x1f\x7f]/.test(code)) {
    throw new TypeError('A valid Shopify discount code is required.');
  }
  if (typeof redirectPath !== 'string' || !redirectPath.startsWith('/') || redirectPath.startsWith('//') || /[\\\x00-\x20\x7f]/.test(redirectPath)) {
    throw new TypeError('redirectPath must be a path within the storefront.');
  }
  const destination = new URL(redirectPath, store.origin);
  if (destination.origin !== store.origin) throw new TypeError('The redirect must stay on the storefront.');
  return store.origin + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination.pathname + destination.search + destination.hash);
}

if (!customElements.get('glowmela-plinko')) {
  customElements.define('glowmela-plinko', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.preview = this.config.preview === true;
      this.inline = this.hasAttribute('data-inline');
      this.dialog = this.querySelector('.sp-dialog');
      this.status = this.querySelector('[data-status]');
      this.key = 'glowmela-plinko-v1-' + this.config.campaign;
      this.slots = [0, 1, 2, 3];
      this.reward = null;
      this.result = null;
      this.state = 'ready';
      this.querySelectorAll('[data-preview-only]').forEach(el => el.hidden = !this.preview);
      this.querySelectorAll('[data-live-only]').forEach(el => el.hidden = this.preview);
      this.querySelectorAll('[data-slot]').forEach((el, i) => {
        el.querySelector('span').textContent = this.config.rewards[this.slots[i]].percent + '%';
      });
      this.makePegs();
      this.bind('[data-drop]', 'click', () => this.play());
      this.bind('[data-close]', 'click', () => this.close());
      this.bind('[data-open]', 'click', () => this.open());
      this.bind('[data-replay]', 'click', () => this.reset());
      this.bind('[data-claim-form]', 'submit', e => this.submit(e));
      if (this.inline) {
        this.querySelector('[data-claim-button]').type = 'button';
        const claimPreview = e => {
          e.preventDefault();
          if (this.querySelector('[data-claim-form]').reportValidity()) this.submit(e);
        };
        this.bind('[data-claim-button]', 'click', claimPreview);
        this.bind('[data-email]', 'keydown', e => { if (e.key === 'Enter') claimPreview(e); });
      }
      this.bind('[data-shop]', 'click', e => {
        if (this.state === 'expired') { e.preventDefault(); return; }
        if (this.preview) {
          e.preventDefault();
          this.status.textContent = this.config.strings.previewShop;
        }
      });
      if (!this.inline) {
        this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.close(); }, {signal:this.abort.signal});
        this.dialog.addEventListener('click', e => {
          if (e.target === this.dialog) {
            const b = this.dialog.getBoundingClientRect();
            if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) this.close();
          }
        }, {signal:this.abort.signal});
      }
      this.restore();
      const formReturn = !!this.querySelector('[data-form-return]');
      if (formReturn) this.autoTimer = setTimeout(() => this.open(), 100);
      else if (this.preview || (this.config.autoOpen && !this.read('seen') && !this.read('dismissed'))) {
        const arrival = this.read('arrival') || Date.now();
        this.write('arrival', arrival);
        const delay = Math.max(0, this.config.delay * 1000 - (Date.now() - arrival));
        this.autoTimer = setTimeout(() => this.open(), this.preview ? 100 : delay);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) document.documentElement.classList.remove('glow-drop-open');
      clearTimeout(this.autoTimer);
      clearTimeout(this.transitionTimer);
      clearInterval(this.expiryTimer);
      cancelAnimationFrame(this.frame);
    }
    bind(selector, event, action) {
      this.querySelectorAll(selector).forEach(el => el.addEventListener(event, action, {signal:this.abort.signal}));
    }
    read(key) {
      if (this.preview) return null;
      try { return JSON.parse(sessionStorage.getItem(this.key + '-' + key)); } catch { return null; }
    }
    write(key, value) {
      if (this.preview) return;
      try { sessionStorage.setItem(this.key + '-' + key, JSON.stringify(value)); } catch {}
    }
    open() {
      if (this.inline) this.dialog.hidden = false;
      else if (!this.dialog.open) {
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('glow-drop-open');
      }
      this.write('seen', true);
      this.querySelector('[data-open]').hidden = true;
    }
    close() {
      if (this.inline) this.dialog.hidden = true;
      else {
        this.dialog.close();
        document.documentElement.classList.remove('glow-drop-open');
        this.previousFocus?.focus({preventScroll:true});
      }
      clearTimeout(this.autoTimer);
      this.querySelector('[data-open]').hidden = false;
      this.write('dismissed', true);
    }
    screen(name) {
      this.querySelectorAll('[data-screen]').forEach(el => el.hidden = el.dataset.screen !== name);
    }
    makePegs() {
      const group = this.querySelector('[data-pegs]');
      const ns = 'http://www.w3.org/2000/svg';
      for (let row = 0; row < 9; row++) {
        for (let col = 0; col <= row; col++) {
          const peg = document.createElementNS(ns, 'circle');
          peg.setAttribute('cx', 180 + (2 * col - row) * 15);
          peg.setAttribute('cy', 48 + row * 22);
          peg.setAttribute('r', '3.4');
          peg.setAttribute('class', 'sp-peg');
          group.append(peg);
        }
      }
    }
    randomInt(n) {
      const value = new Uint32Array(1);
      crypto.getRandomValues(value);
      return Math.floor(value[0] / 4294967296 * n);
    }
    ball(x, y) { this.querySelector('[data-ball]').setAttribute('transform', `translate(${x} ${y})`); }
    play() {
      if (this.state !== 'ready') return;
      this.state = 'playing';
      const button = this.querySelector('[data-drop]');
      button.disabled = true;
      button.textContent = this.config.strings.dropping;
      this.status.textContent = this.config.strings.dropping;
      this.result = this.randomInt(this.slots.length);
      this.reward = this.config.rewards[this.slots[this.result]];
      this.write('result', this.result);
      const right = this.result * 3;
      const directions = Array.from({length:9}, (_, i) => i < right ? 1 : -1);
      for (let i = 8; i > 0; i--) {
        const j = this.randomInt(i + 1);
        [directions[i], directions[j]] = [directions[j], directions[i]];
      }
      const points = [{x:180,y:18},{x:180,y:37}];
      let x = 180;
      directions.forEach((step, row) => { x += step * 15; points.push({x,y:59 + row * 22}); });
      points.push({x,y:264});
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.ball(x, 264);
        this.finish();
        return;
      }
      let started;
      const duration = 2750;
      const animate = now => {
        if (!this.isConnected) return;
        if (!started) started = now;
        const progress = Math.min((now - started) / duration, 1) * (points.length - 1);
        const i = Math.min(Math.floor(progress), points.length - 2);
        const t = Math.min(progress - i, 1);
        const a = points[i], b = points[i+1];
        this.ball(a.x + (b.x-a.x)*t, a.y + (b.y-a.y)*t - (i > 0 && i < 10 ? 12*Math.sin(Math.PI*t) : 0));
        if (progress < points.length - 1) this.frame = requestAnimationFrame(animate);
        else this.finish();
      };
      this.frame = requestAnimationFrame(animate);
    }
    finish() {
      this.state = 'won';
      this.querySelectorAll('[data-slot]')[this.result].classList.add('sp-won');
      this.status.textContent = this.config.strings.won.replace('{reward}', this.reward.percent + '%');
      this.transitionTimer = setTimeout(() => this.showClaim(), matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 700);
    }
    showClaim() {
      this.querySelectorAll('[data-percent]').forEach(el => el.textContent = this.reward.percent + '%');
      this.screen('claim');
      this.state = 'claim';
    }
    submit(event) {
      if (this.state !== 'claim' || !this.reward) { event.preventDefault(); return; }
      if (this.preview) {
        event.preventDefault();
        this.querySelector('[data-email]').value = '';
        this.showReward();
      } else {
        this.write('pending', true);
        this.state = 'submitting';
        const button = this.querySelector('[data-claim-button]');
        button.disabled = true;
        button.textContent = this.config.strings.saving;
      }
    }
    showReward() {
      if (!this.reward) return;
      this.state = 'claimed';
      this.querySelectorAll('[data-percent]').forEach(el => el.textContent = this.reward.percent + '%');
      const code = this.preview ? 'PREVIEW-' + this.reward.percent : this.reward.code;
      this.querySelector('[data-code]').textContent = code;
      this.querySelector('[data-code]').hidden = false;
      this.querySelector('[data-shop]').removeAttribute('aria-disabled');
      this.querySelector('[data-shop]').href = this.preview ? '#' : glowmelaDiscountLink({storeUrl:this.config.storeUrl, code, redirectPath:this.config.shopUrl});
      this.screen('reward');
      this.status.textContent = this.preview ? this.config.strings.previewComplete : this.config.strings.ready;
      this.querySelector('[data-expiry]').hidden = true;
    }
    restore() {
      const result = this.read('result');
      if (!Number.isInteger(result) || result < 0 || result >= this.slots.length) return;
      this.result = result;
      this.reward = this.config.rewards[this.slots[result]];
      if (this.querySelector('[data-form-success]') && this.read('pending')) {
        this.write('claimed', true);
        this.write('pending', false);
      }
      if (this.read('claimed')) this.showReward();
      else this.showClaim();
    }
    reset() {
      if (!this.preview) return;
      clearTimeout(this.autoTimer);
      clearTimeout(this.transitionTimer);
      clearInterval(this.expiryTimer);
      this.previewDeadline = null;
      this.querySelector('[data-expiry]').hidden = true;
      cancelAnimationFrame(this.frame);
      this.state = 'ready';
      this.reward = null;
      this.result = null;
      this.screen('game');
      this.querySelector('[data-drop]').disabled = false;
      this.querySelector('[data-drop]').textContent = this.config.strings.drop;
      this.querySelectorAll('.sp-won').forEach(el => el.classList.remove('sp-won'));
      this.querySelector('[data-claim-form]').reset();
      this.ball(180,18);
      this.status.textContent = '';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
